import React from 'react';

import { Stack, Text } from '@eluve/components';
import {
  useAppointmentStatus,
  useSummary,
} from '@eluve/frontend-appointment-hooks';

export const SummarizationErrorCard: React.FC = () => {
  const appointmentStatus = useAppointmentStatus();
  const { isSummaryAvailable } = useSummary();

  if (isSummaryAvailable || appointmentStatus !== 'COMPLETED') {
    return null;
  }

  return (
    <Stack
      className="h-96 rounded-xl border bg-white"
      align="center"
      justify="center"
      gap={1}
    >
      <Text>No summary available for this appointment</Text>
    </Stack>
  );
};
